module.exports = __webpack_public_path__ + "static/img/icon-screen.a6446944.svg";